// @flow
import moment from 'moment'
import searchPriceBuilder from './tripPrice'
import buildOndemandStep from './ondemandSearchStep'
import buildRideLocation from './rideLocation'
import { isCancelationFree, getAccurateTime } from '../../../models/step'

// Types
import type { Trip } from '../../../models/trip'
import type {
  OndemandSearchRide,
  OndemandSearchResponse,
} from '../../../api_types'

/**
 * By given trip and response object return unified trip object
 * @param {0bject} trip The trip object
 * @param {Object} response The whole search response object
 * @return {Object}
 * @private
 */
function ondemandSearchTripBuilder(
  ride: OndemandSearchRide,
  response: OndemandSearchResponse
): Trip {
  const parsedPrice = searchPriceBuilder({
    price: ride.fixed,
    estimates: ride.estimates,
    cost: ride.cost,
  })

  const allSteps = [
    buildOndemandStep(
      {
        main: true,
        step_type: 'car',
        details: ride,
      },
      response
    ),
  ]

  return {
    id: ride.id || '',
    type: 'ondemand',
    searchId: response.id,
    price: parsedPrice,
    totalPrice: parsedPrice.raw,
    steps: allSteps,
    returnSteps: [],
    duration: getAccurateTime(allSteps),
    recommended: false,
    discountPercentage: null,
    freeCancellation: isCancelationFree(allSteps),
    isEstimate: true,
    tags: [],
    createdAt: moment(),
    expiresAt: response.expires_at,
    expiresIn: response.expires_in,
    rewardPoints: 0,
    rewardProgram: null,
    rewardProgramDisplay: null,
    flightType: '',
    numPassengers: response.num_passengers,
    flightDatetime: null,
    returnFlightDatetime: null,
    pickupDatetime: response.pickup_datetime
      ? moment.parseZone(response.pickup_datetime)
      : null,
    returnPickupDatetime: null,
    startLocation: response.start_location
      ? buildRideLocation(response.start_location)
      : null,
    endLocation: response.end_location
      ? buildRideLocation(response.end_location)
      : null,
    // missing in v2
    taxesAndFeesIncluded: true,
    outOfPolicy: false,
    vehiclesIncluded: [],
    preferred: false,
    preferredByCompany: false,
  }
}

export default ondemandSearchTripBuilder
